import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import {
  providerBrandingService,
  ProviderBrandingRequestError,
} from '@/services/provider/branding.service';
import type {
  ProviderBrandingSettings,
  UpdateProviderBrandingInput,
} from '@/types/provider-branding';

export const providerBrandingKeys = {
  all: ['provider', 'branding-settings'] as const,
  detail: () => [...providerBrandingKeys.all, 'detail'] as const,
};

export function useProviderBrandingSettings(enabled = true) {
  return useQuery<ProviderBrandingSettings, ProviderBrandingRequestError>({
    queryKey: providerBrandingKeys.detail(),
    queryFn: () => providerBrandingService.getSettings(),
    enabled,
  });
}

export function useUpdateProviderBrandingSettings() {
  const queryClient = useQueryClient();

  return useMutation<ProviderBrandingSettings, ProviderBrandingRequestError, UpdateProviderBrandingInput>({
    mutationFn: (input) => providerBrandingService.updateSettings(input),
    onSuccess: (settings) => {
      queryClient.setQueryData(providerBrandingKeys.detail(), settings);
    },
  });
}
